module.exports = __webpack_public_path__ + "static/media/stop-10.7114eb1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/stop-10.svg
// module id = 1355
// module chunks = 0